import React, { useState, useEffect } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import IndividualContent from './IndividualContent';

const INIT_FILTER = {
  q: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'CDL',
  sort_by: 'desc',
  transaction_type: 'INDIVIDUAL',
};

export const cedulaStatusOption = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR EVALUATION', value: 'FOR CHECKING' },
  { label: 'FOR PAYMENT', value: 'PENDING' },
  { label: 'FOR PAYMENT CONFIRMATION', value: 'FOR PAYMENT CONFIRMATION' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'ISSUED', value: 'ISSUED' },
  { label: 'REVOKED', value: 'REVOKED' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'CANCELLED', value: 'CANCELLED' },
];

function IndividualContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  showTransaction,
  startAssessment,
  tagAsPrintedTransaction,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);

  // Get transaction list when filter change
  useEffect(() => {
    getTransactionList(debouncedFilter);
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));

    // if (key === keywordLength) setCountChar(keywordLength);
  };

  const handleTagAsPrinted = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to tag this application for pick-up?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          tagAsPrintedTransaction(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const getExtName = (item) =>
    _.get(item, 'included.module.attributes.extension_name');

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={cedulaStatusOption}
            moduleName="Individual Transactions"
            // getData={getTransactionList}
            // setParams={param}
            setKeyword={(e) =>
              handleOnChange(
                e?.target.name,
                e?.target.value
                // e?.target.value.length
              )
            }
            setStatusFilter={(props) =>
              handleOnChange('transaction_status', props?.value)
            }
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Transaction..."
            listName="Transaction"
            label="Transaction List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {`${_.get(item, 'included.module.attributes.first_name')} ${
                    _.get(item, 'included.module.attributes.middle_name') || ''
                  } 
                  ${_.get(item, 'included.module.attributes.last_name')}  ${
                    getExtName(item) || ''
                  }`}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {' '}
                  {_.get(item, 'included.module.attributes.birth_date')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <IndividualContent onTagAsPrinted={handleTagAsPrinted} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleSort={(props) => handleOnChange('sort_by', props?.value)}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

IndividualContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  tagAsPrintedTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(IndividualContainer);
